/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VoiceOfCustomerType = 'Bug' | 'Feature' | 'Report' | 'Others';

export const VoiceOfCustomerType = {
    Bug: 'Bug' as VoiceOfCustomerType,
    Feature: 'Feature' as VoiceOfCustomerType,
    Report: 'Report' as VoiceOfCustomerType,
    Others: 'Others' as VoiceOfCustomerType
};

